import { useState, useEffect } from 'react';

/**
 * useClientState
 *
 * @param getInitialValue - функция, которая возвращает начальное значение (только на клиенте)
 * @param fallback - значение по умолчанию при серверном рендеринге
 */
export function useClientState<T>(
  getInitialValue: () => T | T,
  fallback: T,
): [T, React.Dispatch<React.SetStateAction<T>>] {
  const [state, setState] = useState<T>(fallback);

  useEffect(() => {
    const value = getInitialValue();
    if (value !== undefined) {
      setState(value);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [state, setState];
}
